import * as Yup from "yup";
import type { DogCovered, DogQuote } from "@/api_client";
import type { DogEntryContent } from "@/services/cms/contentTypes/entry/DogEntryContent";
import { getErrorMessageNew } from "@/utils/errorMessage";
import { AgeValidator } from "@/validators/shared/ageValidators";
import { FinnishSSN } from "@/validators/shared/ssnValidator";

const validateSSN = (ssn: string) => {
  const finnishSSN = new FinnishSSN(ssn);
  return finnishSSN.validateSSN();
};

export type DogEntryFormObject = Pick<
  DogQuote,
  "dogCovered" | "policyHolderSsn"
>;

type DogEntryContentData = DogEntryContent | undefined | null;

export const ResolveDogEntry = (
  content: DogEntryContentData,
): Yup.ObjectSchema<DogEntryFormObject> =>
  Yup.object({
    policyHolderSsn: Yup.string()
      .required(
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "required",
        ),
      )
      .test(
        "valid-ssn",
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "valid-ssn",
        ),
        validateSSN,
      )
      .test(
        "is-18+",
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "is-18+",
        ),
        (ssn: string) => {
          const ageValidator = new AgeValidator(ssn);
          return ageValidator.isAtLeast18;
        },
      ),
    dogCovered: ResolveDogCovered(content),
  });

const ResolveDogCovered = (content: DogEntryContentData) =>
  Yup.object<DogCovered>({
    dogBreed: Yup.string().required(
      getErrorMessageNew(content?.dogBreed?.ValidationMessages, "required"),
    ),
    dogName: Yup.string()
      .required(
        getErrorMessageNew(content?.dogName?.ValidationMessages, "required"),
      )
      .max(
        30,
        getErrorMessageNew(content?.dogName?.ValidationMessages, "max-length"),
      ),
  });
